<m-expansion-panel [id]="'partiSocietaria'" [title]="'Participação societária ('+contadorParticipacaoSocietaria+')'"[active]="larguraEhSuperiorMin">
  <div *ngIf="contadorParticipacaoSocietaria > 0" class="table-responsive" id="div-table-partiSocietaria">
    <table id="id-table-partiSocietaria" class="table table-sm table-striped table-borderless" aria-label="Tabela de participação societária" style="font-size: smaller;">
      <thead>
        <tr>
          <th scope="col">Empresa</th>
          <th scope="col">CNPJ</th>
          <th scope="col">Sócio desde</th>
          <th scope="col">Participação</th>
          <th scope="col">Situação</th>
          <th scope="col">UF</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sociedade of participacaoSocietaria.sociedades; index as i">
          <td>{{ sociedade.razaoSocial | naoinformado }}</td>
          <td>{{ sociedade.cnpj | naoinformado }}</td>
          <td>{{ sociedade.desde | naoinformado }}</td>
          <td>{{ sociedade.participacao | naoinformado }}</td>
          <td>{{ sociedade.status | naoinformado }}</td>
          <td>{{ sociedade.uf | naoinformado }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div id="id-div-partiSocietaria-falha"
    *ngIf="listaServicoFalha.includes('participacao-societaria') || contadorParticipacaoSocietaria == 0">
    {{participacaoSocietaria.falhaServico.message}}
  </div>

</m-expansion-panel>
